import { withStyles } from '@material-ui/core/styles';
import { Box, Step, Stepper, StepLabel, StepConnector } from '@material-ui/core';
import { Check } from '@material-ui/icons';

const QontoConnector = withStyles((theme) => ({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderColor: theme.palette.type === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}))(StepConnector);

const QontoStepIconRoot = withStyles((theme) => ({
  root: {
    color: theme.palette.type === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: theme.palette.primary.main,
  },
  completedIcon: {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 18,
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}))(({ classes, active, completed }) => {
  return (
    <div className={`${classes.root} ${active ? classes.active : ''}`}>
      {completed ? (
        <Check className={classes.completedIcon} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
});

function CustomStepper({ steps, activeStep, ...props }) {
  return (
    <Box
      component="div" 
      style={{ width: '100%', marginBottom: '20px' }}
      {...props}
    >
      <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIconRoot}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default CustomStepper;